import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import { Upload, Icon } from 'antd';

import ApiService from 'app/services/ApiService';
import { AzureMP } from 'react-azure-mp'
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';

import { fetchAccessComponent, accessComponentClear } from '../../actions/AccessComponentActions';
import { generateBlob } from '../../actions/BlobActions';
import { fetchCourseMultimedia, clearCourseMultimedia } from 'app/actions/CourseMultimediaActions';


import { accessComponent } from '../../reducers/index';
import { getCourseMultimedia } from 'app/reducers';
import isEmpty from 'app/utils/IsEmpty';
import MediaPlayer from 'app/components/MediaPlayer';

const useStyles = makeStyles(theme => ({
	root: {
		flexGrow: 1,
		overflow: 'hidden',
		padding: theme.spacing(0, 3),
	},
	paper: {
		maxWidth: 620,
		margin: `${theme.spacing(1)}px auto`,
		padding: theme.spacing(2),
	}
}));

export default function AzureMPContainer(props) {
	const classes = useStyles();
	const dispatch = useDispatch();
	const access = useSelector(accessComponent);
	const courseMultimedia = useSelector(getCourseMultimedia);
	const reader = new FileReader();
	const { Dragger } = Upload;
	const [b64Img, setb64] = useState();
	const [state, setState] = useState({
		accessData: {},
		duration: 0,
		fileList: [],
		finishedOrError: false,
		idCourse: props.id,
		loadStatus: 'initial',
		iconName: {
			'initial': 'cloud-upload',
			'loading': 'loading',
			'success': 'smile',
			'error': 'frown',
		},
		urlStream: '',
		dashStream: '',
		hlsStream: '',
		thumbnail: ''
	});

	const [videoData, setVideoData] = useState({
		urlStream: '',
		dashStream: '',
		hlsStream: '',
		thumbnail: ''
	});

	const [querySelector] = useState({
		button: {},
		canvas: {},
		cxt: '',
		video: {}
	});
	const params = props.children({ state, courseMultimedia });
	const fetchAccess = () => dispatch(fetchAccessComponent(state.idCourse));
	const fetchCourseMultimediaAction = () => dispatch(fetchCourseMultimedia(state.idCourse));
	const getBlob = (data, file, token) => dispatch(generateBlob(data, file, token));

	useEffect(() => {
		if (isEmpty(access)) fetchAccess();
		if (isEmpty(courseMultimedia)) fetchCourseMultimediaAction();

		

		return () => {
			dispatch(accessComponentClear())
		}
	}, []);

	const {
		siteId
	} = useSelector(state => state.Auth)

	const disabledProp = () => {
		if (props.disabled != undefined) {
			return props.disabled;
		}
		return false;
	}
	const createContainer = (file, accessData) => new Promise(async (resolve, reject) => {
		state.loadStatus = 'loading';
		await fetchAccess();
		await getBlob(state, file, accessData, migrateData);
		await mediaDuration(state.fileList[0]).then(
			result => {
				createVideoCanvas(file).then(
					resultV => {
						const _CANVAS = querySelector.canvas;
						const video = querySelector.video;
						querySelector.video.currentTime = Math.floor(Math.random() * parseInt(state.duration)) + 1;
						const _CTX = _CANVAS.getContext("2d");
						setTimeout(function () {
							_CTX.drawImage(video, 0, 0, _CANVAS.width, _CANVAS.height);
						}, 1000);
						// ctx.drawImage(image, 33, 71, 104, 124, 21, 20, 600, 400)
						setTimeout(function () {
							const myImage = _CANVAS.toDataURL("image/png", 0.1);
							setb64({ ...myImage })
							resolve(myImage);
							migrateData(myImage, state, accessData);
						}, 6000);
					}
				);
			});

	});

	const mediaDuration = (file) => new Promise((resolve, reject) => {
		reader.readAsDataURL(file);
		reader.onload = function () {
			const media = new Audio(reader.result);
			media.onloadedmetadata = function () {
				state.duration = media.duration;
				resolve(media.duration); // this would give duration of the video/audio file
			};
		}
	});

	const createVideoCanvas = async (file) => new Promise((resolve, reject) => {
		const _VIDEO = querySelector.video;
		resolve(_VIDEO.setAttribute('src', URL.createObjectURL(file[0])));
	});

	const migrateData = async (imageData, data, accessdata) => {
		const image = imageData.toString().replace('data:image/png;base64,', '');
		const duration = Math.floor(data.duration);
		data = {
			idCourse: state.idCourse,
			multimediaName: data.fileList[0].name,
			videoLength: duration,
			assetId: accessdata.assetId,
			imageData: image
		}
		dispatch(clearCourseMultimedia());
		await ApiService.setMigrateMediaServices(data).then(
			result => {
				
				dispatch(fetchCourseMultimedia(state.idCourse))
				setState({ ...state, loadStatus: 'success', urlStream: '' });     
				setVideoData({
					urlStream: result.video,
					hlsStream: '',
					dashStream: '',
					time:0,
					thumbnail: result.thumbnail
				});
				setState({ ...state, loadStatus: 'success', urlStream: result.video });
				props.setVideo(false);
			}, error => {
				setState({ ...state, loadStatus: 'error' })
				state.loadStatus = 'error';
				props.setVideo(false);
			}
		);
	}

	const actions = {
		onRemove: file => {
			const index = state.fileList.indexOf(file);
			const newFileList = state.fileList.slice();
			newFileList.splice(index, 1);
			setState({ ...state, fileList: newFileList })
		},
		beforeUpload: file => {
			var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
				var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
				return v.toString(16);
			});
			var secciones = file.name.split(".");
			let filedataMedia = new File([file], uuid + "." + secciones[secciones.length - 1], {
				type: file.type,
				uid: file.uid,
				webkitRelativePath: file.webkitRelativePath,
				lastModified: Date.now()
			});

			state.fileList = [filedataMedia];
			const formData = new FormData();
			state.fileList.forEach(fileData => {
				formData.append('files[]', fileData);
			});
			state.isLoading = true;
			props.setVideo(true)
			createContainer(state.fileList, access);
			return false
		},
		state,
	};

	const draggerText = {
		Text: function () {
			return (
				<div>
					<p className="ant-upload-drag-icon">
						<Icon type={state.iconName[state.loadStatus]} />
					</p>
					<p className="ant-upload-text">
						{state.loadStatus === 'initial' ? 'Selecciona o arrastra un archivo' : '...'}
					</p>
					<p className="ant-upload-hint">
						{state.loadStatus === 'initial' ? 'Únicamente formatos .mp4' : ''}
					</p>
				</div>
			)
		},
		finishedText: function () {
			return (
				<div>
					<p className="ant-upload-drag-icon">
						<Icon type={state.iconName[state.loadStatus]} />
					</p>
					<p className="ant-upload-text">
						{state.loadStatus === 'success' ? 'Carga de video exitosa!' : 'Ops! ocurrio un error, intente nuevamente.'}
					</p>
				</div>
			)
		}
	}

	if (Object.keys(courseMultimedia).length !== 0) {
		if (state.urlStream === '') {
		
			state.urlStream = courseMultimedia.Data[0].video;
			state.hlsStream = courseMultimedia.Data[0].hls;
			state.dashStream = courseMultimedia.Data[0].dash;
			state.thumbnail = courseMultimedia.Data[0].thumbnail;
		}
		if (videoData.urlStream === '') {     
			setVideoData({
                urlStream: state.urlStream,
                hlsStream: state.hlsStream,
                dashStream: state.dashStream,
				time:0,
                thumbnail: state.thumbnail
            });
		}      
	}

	return params && (
		<div className={classes.root}>
			<Dragger {...actions} disabled={(state.loadStatus !== 'initial' || siteId !== 'HUB') || disabledProp()} accept="video/mp4">
				{state.loadStatus === 'initial' || state.loadStatus === 'loading' ? <draggerText.Text /> : <draggerText.finishedText />}
			</Dragger>
			<div style={{ visibility: 'hidden', position: 'fixed' }}>
				<Button ref={id => querySelector.button = id}>{''}</Button>
				<video controls width='152' height='112' ref={id => querySelector.video = id}>
					<source type='video/mp4' />
				</video>
				canvas<canvas ref={id => querySelector.canvas = id}>hello</canvas>hello
			</div>
			{ state.urlStream === '' ? <div /> : <MediaPlayer videoData={videoData} parent={"Course"}></MediaPlayer> } 
			
		</div >
	);
}